import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["name", "value", "checked", "disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-item__icon" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "checkbox-item__sub"
}

import {
  useAttrs,
  withDefaults,
  defineOptions,
} from "vue";
import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  checked?: boolean;
  value?: string;
  label?: string;
  subLabel?: string;
  name?: string;
  disabled?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'checkbox-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    checked: { type: Boolean },
    value: {},
    label: {},
    subLabel: {},
    name: {},
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props;




const attrs = useAttrs();


const updateModelValue = (e: Event) => {
  const isChecked = (e.target as HTMLInputElement).checked;
  const getValue = (e.target as HTMLInputElement).value;
  if (attrs.modelValue instanceof Array) {
    let newValue = [...attrs.modelValue];
    if (isChecked) {
      newValue.push(getValue);
    } else {
      newValue = newValue.filter((item) => ![getValue].includes(item));
    }
    emit("update", newValue);
  } else {
    emit("update", isChecked);
  }
};

const changeEvent = (e: Event) => {
  updateModelValue(e);
};

const statusChecked = (): boolean => {
  if (props.checked && true) {
    return true;
  }
  if (typeof attrs.modelValue === "boolean") {
    return attrs.modelValue;
  }
  if (attrs.modelValue instanceof Array) {
    return Object.values(attrs.modelValue).includes(attrs.value);
  }
  return false;
};

const componentClass = () =>
  mapModifires(
    "checkbox-item",
    mergeModifires(props.modifires, props.disabled && "disabled")
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["checkbox-item__label", { 'checkbox-item__label_has_sub': _ctx.subLabel }])
    }, [
      _createElementVNode("input", _mergeProps({ onChange: changeEvent }, _ctx.$attrs, {
        class: "checkbox-item__input",
        name: _ctx.name,
        type: "checkbox",
        value: _ctx.value,
        checked: statusChecked(),
        disabled: _ctx.disabled
      }), null, 16, _hoisted_1),
      _hoisted_2,
      _createElementVNode("span", {
        class: _normalizeClass(["checkbox-item__txt", {
          'checkbox-item__txt_long':
            _ctx.subLabel?.length >= 1 && _ctx.label?.length >= 10,
          'checkbox-item__txt_has_sub': _ctx.subLabel,
        }])
      }, [
        _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
        (_ctx.subLabel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["checkbox-item__txt_sub", { 'checkbox-item__txt_sub_long': _ctx.subLabel?.length >= 20 }])
            }, _toDisplayString(_ctx.subLabel), 3))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2),
    (_ctx.$slots.sub)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "sub")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})